import React from 'react';

export function usePagination(items = [], pageSize = 20) {
  const [page, setPage] = React.useState(1);
  const totalPages = Math.ceil(items.length / pageSize);
  const safePage = Math.min(page, Math.max(1, totalPages));
  const paginated = items.slice((safePage - 1) * pageSize, safePage * pageSize);
  return { paginated, page: safePage, setPage, totalPages, total: items.length };
}

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;
  const pages = [];
  let start = Math.max(1, page - 3);
  let end   = Math.min(totalPages, start + 6);
  start = Math.max(1, end - 6);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="pagination">
      <button onClick={() => onChange(page - 1)} disabled={page === 1}>‹ Prev</button>
      {pages.map(p => (
        <button key={p} className={page === p ? 'active' : ''} onClick={() => onChange(p)}>{p}</button>
      ))}
      <button onClick={() => onChange(page + 1)} disabled={page >= totalPages}>Next ›</button>
    </div>
  );
}
